import * as styles from "./styles.css";
import { useState, useEffect } from "react";
export function KebabMenuContinueWatch({ items, kebabMenuItemHandlerCW, origin, }) {
    const [menu, openMenu] = useState(false);
    useEffect(() => {
        document.addEventListener("click", (event) => {
            const wrapperElem = document.getElementById("menuWrapper");
            const target = event.target;
            if (wrapperElem) {
                const bounding = wrapperElem.getBoundingClientRect();
                if (bounding.left < 0) {
                    wrapperElem.style.right = "-55px";
                }
            }
            if (target.id !== "kebabContainer") {
                openMenu(false);
            }
        });
    });
    const clickHandlerCW = (label, description, title, id) => {
        openMenu(false);
        kebabMenuItemHandlerCW(label, description, title, id);
    };
    return (React.createElement("div", null,
        origin !== "DESKTOP" && (React.createElement("div", { className: styles.kebabdots, onClick: () => openMenu(!menu) },
            React.createElement("ul", { id: "kebabContainer" },
                React.createElement("li", { id: "kebabContainer" }, "."),
                React.createElement("li", { id: "kebabContainer" }, "."),
                React.createElement("li", { id: "kebabContainer" }, ".")))),
        (menu || origin === "DESKTOP") && (React.createElement("div", { id: "menuWrapper", className: origin === "DESKTOP" ? styles.desktopmenu : styles.mobilemenu }, items &&
            items.map((item, index) => (React.createElement("div", { onClick: (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    clickHandlerCW(item.label, item.description, item.name, item.id);
                }, key: index, className: origin === "DESKTOP"
                    ? styles.desktopinnerbar
                    : styles.mobileinnerbar },
                React.createElement("div", { className: styles.wrapper },
                    origin === "DESKTOP" && (React.createElement("div", { className: styles.xCircle }, "x")),
                    React.createElement("div", { className: origin === "DESKTOP"
                            ? styles.desktoplabel
                            : styles.mobilelabel }, item.label)))))))));
}

